import { useContext } from "react";

import { Box } from "@mui/material";

import { AppContext, ThemeMode } from "@context/context";

import SunLine from "./sun-line.svg";

export const ThemeSwitch = () => {
  const appContext = useContext(AppContext);

  const toggle = () =>
    appContext.updateTheme(
      appContext.theme === ThemeMode.Light ? ThemeMode.Dark : ThemeMode.Light,
    );

  return (
    <Box
      onClick={toggle}
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <SunLine />
    </Box>
  );
};
